import ReactDOMServer from 'react-dom/server';
import * as modeAction from '../../../store/actions/modeAction';
import Translator from '../helpers/Translator';
import { AppNotificationAlert } from '@/layout/AppComponents';

export default function errorHandler(error, customMessage = false) {
  return (dispatch, getState) => {
    if (error?.isGlobal) dispatch(modeAction.setHasError());
    else
      switch (error?.response?.status) {
        case 502:
          AppNotificationAlert({
            title: ReactDOMServer.renderToString(
              <Translator file="user" name="user.error" />
            ),
            position: 'center',
            message:
              customMessage ||
              error?.response?.data?.detail ||
              'Error al subir el archivo. No se guardó ningún dato. Si persiste el error, contacte con incidencias',
            type: 'danger',
            duration: 50000,
          });
          break;
        default:
          AppNotificationAlert({
            title: ReactDOMServer.renderToString(
              <Translator file="user" name="user.error" />
            ),
            message: customMessage ? error?.response?.data?.detail : 'Error',
            type: 'danger',
            duration: 5000,
          });
      }
  };
}
